<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <div class="c-percent-field">
        <input
          v-if        = "!field.readonly"
          :class      = "'qa-' +field.name + '__input'"
          :value      = "value"
          @input      = "update($event.target)"
          ref         = "input"
          type        = "number"
          placeholder = "0.00"
        />
        <input
          v-if        = "field.readonly"
          :class      = "'qa-' +field.name + '__input'"
          :value      = "value"
          type        = "number"
          placeholder = "0.00"
          readonly    = "readonly"
          disabled    = "disabled"
        />
        <div class="c-percent-field__percent-icon">
          <i class="fa fa-percent"></i>
        </div>
      </div>
    </template>
    <template v-if="template === 'detail'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <p
        class  = "u-paragraph"
        :class = "'qa-' + field.name + '__value'"
      >
        {{ formattedNumber(value) }}
      </p>
    </template>
  </div>
</template>


<script>
import $ from 'jquery'
import util from '@/functions'

export default {
  props: ['field', 'value', 'labelClass', 'template'],

  methods: {
    update (target) {
      // using valueAsNumber might clear the input in IE on invalid values
      let value = $(target)[0].value
      var formattedValue = value.trim()

      let maxLength = formattedValue.indexOf('.') !== -1 ? 15 : 14
      if (formattedValue.indexOf('-') !== -1) {
        maxLength = maxLength + 1
      }
      if (formattedValue.length > maxLength) {
        formattedValue = formattedValue.slice(0, maxLength)
      }
      if (formattedValue !== value) {
        // This line prevent user from adding more than 14 or 15 digits in the input
        // normally it should update the model and the input but this doesn't work
        // as expected in here, it just updates the model but not the input value,
        // assigning the value directly into the input fix that issue
        this.$refs.input.value = formattedValue
      }
      this.$emit('input', formattedValue)
    },
    formattedNumber (value) {
      if (typeof value !== 'undefined' && value !== null) {
        var numberArray = value.toString().split('.')
        var integerPart = util.formatNumber(numberArray[0])
        numberArray[0] = integerPart
        return numberArray.join('.') + '%'
      }
      return ''
    }
  }
}
</script>

<style lang="sass" scoped>
  .c-percent-field
    display: block
    position: relative
  .c-percent-field__percent-icon
    border-left: 1px solid #dce0dc
    color: #78818c
    font-family: FontAwesome,Open Sans
    display: block
    font-size: 14px
    padding: 7px 4px 6px 6px
    position: absolute
    right: 30px
    height: 33px
    text-align: center
    top: 1px
    width: 25px
    z-index: 2
</style>



// WEBPACK FOOTER //
// FieldPercent.vue?af907b9a